export default __webpack_public_path__ + "static/media/Titulo_en.9e0a5e77.png";